"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_INFO_FONT_WEIGHT = exports.TEXT_INFO_SIZE = exports.TEXT_INFO_HEADING_LEVEL = exports.TEXT_INFO_ALIGN = exports.TEXT_INFO_DECORATION = exports.TEXT_INFO_BORDER = exports.TEXT_INFO_DISPLAY = exports.TEXT_INFO_KIND = void 0;
exports.TEXT_INFO_KIND = {
    HEADING: 'h',
    PARAGRAPH: 'p',
    SPAN: 'span',
};
exports.TEXT_INFO_DISPLAY = {
    INLINE: 'inline',
    BLOCK: 'block',
    DEFAULT: 'default',
};
exports.TEXT_INFO_BORDER = {
    NONE: 'none',
    ROUNDED: 'rounded',
};
exports.TEXT_INFO_DECORATION = {
    LINE_THROUGH: 'line-through',
    UNDERLINE: 'underline',
    NONE: 'none',
};
exports.TEXT_INFO_ALIGN = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
    JUSTIFY: 'justify',
};
exports.TEXT_INFO_HEADING_LEVEL = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6,
};
exports.TEXT_INFO_SIZE = {
    TITLE1: 'title01',
    TITLE2: 'title02',
    TITLE3: 'title03',
    TITLE4: 'title04',
    TITLE45: 'title045',
    TITLE5: 'title05',
    TITLE6: 'title06',
    TITLE7: 'title07',
    DISPLAY1: 'display01',
    DISPLAY2: 'display02',
    DISPLAY3: 'display03',
    CAPTION1: 'caption01',
    CAPTION2: 'caption02',
    CAPTION3: 'caption03',
};
exports.TEXT_INFO_FONT_WEIGHT = {
    REGULAR: 'font-regular',
    LIGHT: 'font-light',
    BOLD: 'font-bold',
};
//# sourceMappingURL=enums.js.map